import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  Inject,
  Input,
  OnChanges,
  SimpleChanges,
} from '@angular/core';

import { IconService } from '@services/icon/icon.service';

import { MimeTypesEnum } from '@models/enums/mime-type.enum';
import { IS_SERVER } from '@core/config';

@Component({
  standalone: true,
  selector: 'sps-icon',
  templateUrl: './icon.component.html',
  styleUrls: ['./icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconComponent implements OnChanges {
  @Input() set mimeType(mimeType: MimeTypesEnum) {
    this.setIconSrcForMimeType(mimeType);
  }

  @Input() alt: string = null;
  @Input() loading: string = 'lazy';
  @Input() icon: string = null;
  @Input() custom = false;

  constructor(
    @Inject(IS_SERVER) private isServer: boolean,
    private el: ElementRef,
    private cd: ChangeDetectorRef,
    private iconService: IconService
  ) {}

  ngOnChanges(changes: SimpleChanges) {
    if (this.isServer) {
      return;
    }

    if (this.custom) {
      this.getIcon(`img-icon-${this.icon}`).then(svg => this.setIcon(svg));

      return;
    }

    if (changes.icon?.currentValue) {
      this.el.nativeElement.setAttribute('data-icon', changes.icon.currentValue);
    }

    if (changes.alt?.currentValue) {
      this.el.nativeElement.setAttribute('aria-label', changes.alt.currentValue);
    }

    this.cd.markForCheck();
  }
  private setIconSrcForMimeType(mimeType: MimeTypesEnum): void {
    switch (mimeType) {
      case MimeTypesEnum.PDF:
        this.getIcon('img-icon-download').then(svg => this.setIcon(svg));
        break;
    }

    this.cd.markForCheck();
  }

  private async getIcon(icon: string): Promise<string | null> {
    if (this.isServer) {
      return null;
    }

    return await this.iconService.getIcon(icon);
  }

  private setIcon(svg: string | null): void {
    if (!svg) {
      return;
    }

    this.el.nativeElement.innerHTML = svg;
    this.cd.markForCheck();
  }
}
